export default __webpack_public_path__ + "static/media/36.6c85424f.png";